const MAP = {
  attiva: { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", label: "Attiva" },
  in_scadenza: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", label: "In scadenza" },
  scaduta: { bg: "bg-red-50", border: "border-red-200", text: "text-red-700", label: "Scaduta" },
  sospesa: { bg: "bg-slate-100", border: "border-slate-200", text: "text-slate-600", label: "Sospesa" },
  disdetta: { bg: "bg-zinc-100", border: "border-zinc-300", text: "text-zinc-700", label: "Disdetta" },
  nuovo: { bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-700", label: "Nuovo" },
  in_lavorazione: { bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-700", label: "In lavorazione" },
  accettato: { bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-700", label: "Accettato" },
  rifiutato: { bg: "bg-red-50", border: "border-red-200", text: "text-red-700", label: "Rifiutato" },
  rinnovata: { bg: "bg-violet-50", border: "border-violet-200", text: "text-violet-700", label: "Rinnovata" },
  in_emissione: { bg: "bg-fuchsia-50", border: "border-fuchsia-300", text: "text-fuchsia-700", label: "📝 In emissione" },
};

export const StatusBadge = ({ status, testid }) => {
  const cfg = MAP[status] || { bg: "bg-slate-100", border: "border-slate-200", text: "text-slate-700", label: status };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center rounded-full border px-3 py-1 text-sm font-semibold ${cfg.bg} ${cfg.border} ${cfg.text}`}
    >
      {cfg.label}
    </span>
  );
};
